import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import * as objectPath from 'object-path';
// Layout
import {
  LayoutConfigService,
  MenuAsideService,
  MenuOptions,
  OffcanvasOptions,
} from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';
import { DOCUMENT } from '@angular/common';
import { ThemeService } from '../services/theme.service';
import { NavigationService } from '../../../core/services/navigation.service';
import { TaskFilterService } from '../../pages/task/task-filter-utility.service';

@Component({
  selector: 'kt-aside-left',
  templateUrl: './aside-left.component.html',
  styleUrls: ['./aside-left.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsideLeftComponent implements OnInit {
  private offcanvas: any;
  today: number = Date.now();
  @ViewChild('asideMenuOffcanvas', { static: true }) asideMenuOffcanvas: ElementRef;
  @ViewChild('asideMenu', { static: true }) asideMenu: ElementRef;
  viewLink = true;
  asideLogo = '';
  asideClasses = '';
  currentRouteUrl = '';
  insideTm: any;
  outsideTm: any;
  filteredViewMode = false;

  menuCanvasOptions: OffcanvasOptions = {
    baseClass: 'aside',
    overlay: true,
    closeBy: 'kt_aside_close_btn',
    toggleBy: {
      target: 'kt_aside_mobile_toggle',
      state: 'mobile-toggle-active',
    },
  };

  menuOptions: MenuOptions = {
    // submenu setup
    submenu: {
      desktop: {
        // by default the menu mode set to accordion in desktop mode
        default: 'dropdown',
      },
      tablet: 'accordion', // menu set to accordion in tablet mode
      mobile: 'accordion', // menu set to accordion in mobile mode
    },

    // accordion setup
    accordion: {
      expandAll: false, // allow having multiple expanded accordions in the menu
    },
  };

  /**
   * Component Constructor
   *
   * param htmlClassService: HtmlClassService
   * param menuAsideService
   * param layoutConfigService: LayoutConfigService
   * param router: Router
   * param render: Renderer2
   * param cdr: ChangeDetectorRef
   */
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public htmlClassService: HtmlClassService,
    public menuAsideService: MenuAsideService,
    public layoutConfigService: LayoutConfigService,
    private router: Router,
    private render: Renderer2,
    private cdr: ChangeDetectorRef,
    public theme: ThemeService,
    private eRef: ElementRef,
    private renderer: Renderer2,
    private navigationService: NavigationService,
    private taskFilterService: TaskFilterService,
  ) {}

  ngOnInit() {
    this.currentRouteUrl = this.router.url.split(/[?#]/)[0];

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
      this.mobileMenuClose();
      this.cdr.markForCheck();
    });

    const config = this.layoutConfigService.getConfig();

    if (objectPath.get(config, 'aside.menu.dropdown') && this.render) {
      this.render.setAttribute(this.asideMenu.nativeElement, 'data-ktmenu-dropdown', '1');
      // tslint:disable-next-line:max-line-length
      this.render.setAttribute(
        this.asideMenu.nativeElement,
        'data-ktmenu-dropdown-timeout',
        objectPath.get(config, 'aside.menu.submenu.dropdown.hover-timeout'),
      );
    }

    this.asideClasses = this.htmlClassService.getClasses('aside', true).toString();
    this.asideLogo = this.getAsideLogo();
    setTimeout(() => {
      this.offcanvas = new KTOffcanvas(
        this.asideMenuOffcanvas.nativeElement,
        this.menuCanvasOptions,
      );
    });

    if (this.router.url.includes('filtered-view')) {
      this.filteredViewMode = true;
    }
  }
  getAsideLogo() {
    return `./assets/media/logos/smallLogo.PNG`;
  }

  asideLogoFun = (val) => {
    if (val) {
      this.viewLink = false;
      this.cdr.detectChanges();
      return;
    }
    this.viewLink = true;
    this.cdr.detectChanges();
    return;
  };

  /**
   * Check Menu is active
   * @param item: any
   */
  isMenuItemIsActive(item): boolean {
    if (item.submenu) {
      return this.isMenuRootItemIsActive(item);
    }

    if (!item.page) {
      return false;
    }

    return this.currentRouteUrl.indexOf(item.page) !== -1;
  }

  /**
   * Check Menu Root Item is active
   * @param item: any
   */
  isMenuRootItemIsActive(item): boolean {
    let result = false;

    for (const subItem of item.submenu) {
      result = this.isMenuItemIsActive(subItem);
      if (result) {
        return true;
      }
    }

    return false;
  }
  /**
   * Returns Submenu CSS Class Name
   * @param item
   */
  getItemCssClasses(item) {
    let classes = 'menu-item';

    if (objectPath.get(item, 'submenu')) {
      classes += ' menu-item-submenu';
    }

    if (!item.submenu && this.isMenuItemIsActive(item)) {
      classes += ' menu-item-active menu-item-here';
    }

    if (item.submenu && this.isMenuItemIsActive(item)) {
      classes += ' menu-item-open menu-item-here';
    }

    // custom class for menu item
    const customClass = objectPath.get(item, 'custom-class');
    if (customClass) {
      classes += ' ' + customClass;
    }

    if (objectPath.get(item, 'icon-only')) {
      classes += ' menu-item-icon-only';
    }

    return classes;
  }

  getItemAttrSubmenuToggle(item) {
    let toggle = 'hover';
    if (objectPath.get(item, 'toggle') === 'click') {
      toggle = 'click';
    } else if (objectPath.get(item, 'submenu.type') === 'tabs') {
      toggle = 'tabs';
    } else {
      // submenu toggle default to 'hover'
    }

    return toggle;
  }

  mobileMenuClose() {
    if (KTUtil.isBreakpointDown('lg') && this.offcanvas) {
      // Tablet and mobile mode
      this.offcanvas.hide(); // Hide offcanvas after general link click
    }
  }
  navigate(page, type) {
    switch (type) {
      case 'EXTERNAL':
        this.window.open(page, '_blank');
        break;
      case 'INTERNAL':
        this.router.navigateByUrl(page);
        break;
      case 'SCRIPT':
        this.document.head.append(``);
        break;
      default:
        this.navigationService.emptyNavigationStack();
        this.router.navigateByUrl(page);
    }
    if (page === '/task/list') {
      this.taskFilterService.fromDashboard.next(false);
    }
    if (!this.theme.minimized) return;

    setTimeout(() => {
      const openListItems = document.getElementsByClassName('menu-item-open');

      if (openListItems.length)
        Array.from(openListItems).forEach((ls) => ls.classList.remove('menu-item-open'));
    }, 500);
  }
  get window(): Window {
    return this.document.defaultView;
  }

  @HostListener('document:click', ['$event'])
  click(event) {
    if (this.theme.minimized && !this.eRef.nativeElement.contains(event?.target)) {
      const openListItems = document.getElementsByClassName('menu-item-open');

      if (openListItems.length)
        Array.from(openListItems).forEach((ls) => ls.classList.remove('menu-item-open'));
    }
  }

  handleMouseEnter(listItem: HTMLElement, listItemLink: HTMLElement, hasSubmenu: boolean): void {
    setTimeout(() => {
      let isSame = false;
      const listItems = document.querySelectorAll(
        '.aside-minimize .aside-menu .menu-nav > .menu-item',
      );

      listItems.forEach((ls) => {
        if (listItem.isSameNode(ls)) isSame = true;
      });

      if (!isSame) return;

      hasSubmenu ? listItemLink.click() : this.click(null);
    }, 100);
  }

  handleMouseClick(listItem: HTMLElement): void {
    setTimeout(() => {
      listItem.classList.toggle('rotate-arrow');

      let isSame = false;
      const listItems = document.querySelectorAll(
        '.aside-minimize .aside-menu .menu-nav > .menu-item.menu-item-open:not([data-menu-submenu-mode=accordion])',
      );

      listItems.forEach((ls) => {
        if (listItem.isSameNode(ls)) isSame = true;
      });

      if (!isSame) return;

      const listItemMenu = listItem.querySelector('.menu-submenu');
      const listItemMenuNavContainer = listItem.querySelector(
        '.menu-submenu > .menu-subnav > .subnav-container',
      );
      const listItemRect = listItem.getBoundingClientRect();
      const menuMaxHeight = 300;

      if (listItemRect.top + menuMaxHeight + 100 > window.innerHeight) {
        this.renderer.setStyle(
          listItemMenu,
          'top',
          `${window.innerHeight - (menuMaxHeight + 100)}px`,
        );
      } else {
        this.renderer.setStyle(listItemMenu, 'top', `${listItemRect.top}px`);
      }

      this.renderer.setStyle(listItemMenuNavContainer, 'max-height', `${menuMaxHeight}px`);
      this.renderer.setStyle(listItemMenuNavContainer, 'overflow-y', 'scroll');
    }, 100);
  }
}
